import React from 'react';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import './AnnouncementPreview.scss';

const AnnouncementPreview = props => {
	const { color, isPad, from, padding, margin, includeHeaders } = props;
	const fromButton = from === 'WidgetButton';
	const fromPreview = from === 'Preview';
	return (
		<div className="WidgetPreviews">
			<div className={!fromButton ? 'hover-wrap' : null}>
				{!from && <div className="hover-container">Announcements</div>}
				<div className="column-container" style={{ margin }}>
					{!fromButton && includeHeaders && (
						<div className="divider">
							<div className="line" style={{ backgroundColor: color }}></div>
							<h3 style={{ color }}>Announcements</h3>
							<div className="line" style={{ backgroundColor: color }}></div>
						</div>
					)}
					<div
						className="announcement-preview"
						style={{ padding, cursor: fromPreview ? 'default' : 'pointer' }}
					>
						<div
							className="announcement-icon"
							style={{ marginRight: fromButton || fromPreview ? '1em' : isPad ? '2em' : '1.5em' }}
						>
							<IoMdInformationCircleOutline
								color={color || 'black'}
								size={fromButton ? 24 : fromPreview ? 28 : 36}
							/>
						</div>
						<div className="announcement-info">
							<div
								className="announcement-title"
								style={{
									backgroundColor: color,
									height: fromButton ? '.7em' : fromPreview ? '.8em' : '1em',
								}}
							></div>
							<div
								className="announcement-body line-one"
								style={{ height: fromButton ? '.5em' : fromPreview ? '.7em' : '.9em' }}
							></div>
							<div
								className="announcement-body line-two"
								style={{ height: fromButton ? '.5em' : fromPreview ? '.7em' : '.9em' }}
							></div>
							<div
								className="announcement-time"
								style={{ height: fromButton ? '.4em' : fromPreview ? '.5em' : '.6em' }}
							></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AnnouncementPreview;
